<script setup lang = "ts">

import moment from "moment/moment";

const props = defineProps<{
	created_at: Date,
	updated_at: Date,
	daysLeft?: number,
	watchers: number,
	follows: number,
}>()

const daysLeft = props.daysLeft ?? moment().diff(moment(props.created_at), "days")
const lastUpdate = moment(props.updated_at).format('MMMM DD, YYYY [a las] hh:mm a')

</script>

<template>
	<div class = "flex flex-col mt-5 justify-center text-neutral-700">
		<div>
			<p class = "text-base text-weight-medium text-neutral-900">Última Actualización:</p>
			<p class="text-base">{{ lastUpdate }}</p>
			<slot name = "bottom-last-update"/>
		</div>
		<div class = "flex flex-row flex-grow mt-3">
			<p class = "text-sm text-neutral-600">
				<i class = "fa-solid fa-eye mr-2  text-neutral-800"></i>
				<span class = "text-weight-bold">{{ watchers }}</span>
				vist{{ watchers == 0 ? 'as' : watchers == 1 ? 'a' : 'as' }}
			</p>
			<p class = "text-sm text-neutral-600 ml-5">
				<i class = "fa-solid fa-heart mr-2 text-neutral-800"></i>
				<span class = "text-weight-bold">{{ follows }}</span>
				favorit{{ watchers == 0 ? 'os' : watchers == 1 ? 'o' : 'os' }}
			</p>
		</div>
	</div>
</template>

<style scoped>

</style>